if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        // FG 2026-10-05 (Danial): hidden at the top of the page so the hero shows in full; scrolling up brings it in.
        if (this.isCompareBarShowing() || window.scrollY < 80) {
          this.hide();
        } else {
          this.show();
        }

        this.lastScrollTop = window.scrollY;
        this.scrollDistance = 0;
        this.scrollHandler = FoxTheme.utils.debounce(this.onScrollHandler.bind(this), 10);
        this.init();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
      }

      init() {
        this.calculateHeight();
        window.addEventListener('scroll', this.scrollHandler, false);
      }

      calculateHeight() {
        // FG 2026-10-05: follow the bar's real height (it changed size), so page padding, the chat button and the
        // sticky add-to-cart always clear it.
        const set = () => document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        requestAnimationFrame(set);
        if ('ResizeObserver' in window) new ResizeObserver(set).observe(this);
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      onScrollHandler() {
        if (this.isCompareBarShowing()) {
          this.hide();
          return;
        }

        const offsetTop = document.getElementById('mobileNavStatic').offsetTop;
        const scrollTop = window.scrollY;
        const pointTouch = offsetTop - scrollTop - window.innerHeight;

        requestAnimationFrame(() => {
          const delta = scrollTop - this.lastScrollTop;
          this.lastScrollTop = scrollTop;
          if (delta === 0) return;

          // FG: count distance travelled in one direction so small finger jitters don't flip the bar.
          const direction = delta > 0 ? 'down' : 'up';
          if (direction !== this.scrollDirection) {
            this.scrollDirection = direction;
            this.scrollDistance = 0;
          }
          this.scrollDistance += Math.abs(delta);

          if (pointTouch <= 0) {
            this.hide();
          } else if (scrollTop < 80) {
            this.hide();
          } else if (direction === 'down' && this.scrollDistance > (Number(this.dataset.hideDistance) || 160)) {
            this.hide();
          } else if (direction === 'up' && this.scrollDistance > 16) {
            this.show();
          }
        });
      }

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        document.body.classList.remove(this.classes.isShow);
        document.body.classList.add(this.classes.isHide);
      }
    }
  );
}
